<template>
  <!-- Old bit.dev component -->
  <header
    :class="[isHorizontalStyle, backgroundColor]"
    class="c-base-header-page columns is-gapless is-mobile is-vcentered has-text-centered"
  >
    <div class="column">
      <div class="c-base-header-page__content">
        <!-- Use this slot default for custom content -->
        <slot></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    isHorizontal: {
      type: Boolean,
    },
    backgroundColor: {
      type: String,
    },
  },
  data() {
    return {
      isHorizontalStyle: {
        'c-base-header-page--horizontal': this.isHorizontal,
      },
    }
  },
}
</script>

<style lang="scss">
.c-base-header-page {
  position: relative;
  min-height: 150px;
  border-bottom-right-radius: 50px;
  border-bottom-left-radius: 50px;
  background-color: $gray-2;
  @media (min-width: $tablet) {
    height: 90vh;
    border-bottom-left-radius: 0;
    border-top-right-radius: 50px;
  }
  &__content {
    padding: 16px 0;
  }

  &--horizontal {
    @media (min-width: $tablet) {
      height: auto;
      border-bottom-left-radius: 50px;
      border-top-right-radius: 0;
    }
  }
}
</style>
